export const isInputHidden = (proactiveChat) => {
  const messages = proactiveChat?.initResponse?.initialMessages;
  if (!messages || !messages.length) return false;
  const lastMessage = messages[messages.length - 1];
  return lastMessage?.meta?.template?.templateType !== 'text';
};
